<template>
  <transition>
    <div
      v-if="filterToggle"
      class="pt-2"
    >
      <b-form
        class="border-dashed"
      >
        <b-row>
          <b-col md="3">
            <b-form-group
              :label="$t(filterClass.getLabel(Letter.TO_ORG))"
            >
              <v-select
                :id="Letter.TO_ORG"
                v-model="filters[Letter.TO_ORG]"
                :reduce="(option) => option.id"
                :options="organizationList"
                :get-option-label="(option) => $langName(option.name)"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
              :label="$t(filterClass.getLabel(Letter.PERIOD))"
            >
              <v-select
                :id="Letter.PERIOD"
                v-model="filters[Letter.PERIOD]"
                :reduce="(option) => option.id"
                :options="periods"
                label="admission_year"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
              :label="$t(filterClass.getLabel(Letter.LETTER_STATUS))"
            >
              <v-select
                :id="Letter.LETTER_STATUS"
                v-model="filters[Letter.LETTER_STATUS]"
                :reduce="(option) => option.id"
                :get-option-label="(option) => $langName(option.name)"
                :options="letterStatuses"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
              :label="$t(filterClass.getLabel(Letter.LETTER_TYPE))"
            >
              <v-select
                :id="Letter.LETTER_TYPE"
                v-model="filters[Letter.LETTER_TYPE]"
                :reduce="(option) => option.id"
                :get-option-label="(option) => $langName(option.name)"
                :options="letterTypes"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-button
              variant="success"
              @click="onFilter"
            >
              <feather-icon icon="LFilterIcon" />
              {{ $t('Filter') }}
            </b-button>
          </b-col>
        </b-row>

      </b-form>
    </div>
    <div v-else />
  </transition>
</template>

<script>
import {
  BForm, BButton, BRow, BCol,
  BFormGroup,
} from 'bootstrap-vue'
// eslint-disable-next-line import/no-cycle
import vSelect from 'vue-select'
import { isObject } from '@core/utils/utils'
import Letter from '@/views/components/filters/service/Letter'

export default {
  name: 'CustomersFilterComponent',
  components: {
    vSelect,
    BForm,
    BButton,
    BRow,
    BCol,
    BFormGroup,
  },
  props: {
    filterToggle: {
      type: Boolean,
      required: true,
    },
    filters: {
      type: [Array, Object],
      default: () => ({}),
    },
    filterClass: {
      type: [Object, null],
      default: null,
    },
    selectedFilters: {
      type: [Array],
      default: () => ([]),
    },
  },
  data() {
    return {
      filterCustomer: {},
    }
  },
  computed: {
    Letter() {
      return Letter
    },
    periods() {
      return this.$store.state.staticModule.periodList
    },
    letterStatuses() {
      return this.$store.state.staticModule.letterStatuses
    },
    letterTypes() {
      return this.$store.state.staticModule.letterTypes
    },
    organizationList() {
      return this.$store.state.staticModule.organizationList
    },
  },
  watch: {
    periods(newValue) {
      this.changeValue(newValue, Letter.PERIOD)
    },
    organizationList(newValue) {
      this.changeValue(newValue, Letter.TO_ORG)
    },
  },
  created() {
    this.changeValue(this.letterStatuses, Letter.LETTER_STATUS)
    this.changeValue(this.letterTypes, Letter.LETTER_TYPE)
  },
  methods: {
    onFilter() {
      this.$emit('onFilter', this.filter)
    },
    removeSelectedFilter(path) {
      this.filterClass.removeSelectedFilter(this.filters, path)
      this.$emit('onRemoveSelectedFilter', path)
    },
    removeSearchFilter() {
      this.$emit('searchQueryClear')
    },
    changeValue(newValue, field) {
      if (newValue.length && !isObject(this.filters[field])) {
        this.filters[field] = newValue.find(x => `${x.id}` === this.filters[field])
      }
    },
  },
  setup() {
    return {
    }
  },
}
</script>

<style scoped>

</style>
